import {
  getValidChildren
} from "./chunk-XZIBRHDI.mjs";
import {
  cn
} from "./chunk-DYSUVPH5.mjs";
import {
  compact
} from "./chunk-HEPUUO7U.mjs";

// src/components/input/input-group.tsx
import React, { cloneElement } from "react";
var InputGroup = React.forwardRef(
  ({ children, className, ...props }, ref) => {
    const validChildren = getValidChildren(children);
    const classes = [];
    const classMap = {
      InputLeftElement: ["pl-10"],
      InputRightElement: ["pr-10"],
      InputLeftAddon: ["rounded-l-none"],
      InputRightAddon: ["rounded-r-none"]
    };
    validChildren.forEach((child) => {
      const childType = child.type.id;
      if (classMap[childType]) {
        classes.push(...classMap[childType]);
      }
    });
    const clones = validChildren.map((child) => {
      const { className: chlidClassName, ...childProps } = child.props;
      const theming = compact({
        size: props.size || child.props?.size,
        disabled: props.disabled || child.props?.disabled
      });
      return child.type.id !== "InputV2" ? cloneElement(child, theming) : cloneElement(
        child,
        Object.assign(
          theming,
          {
            className: cn(...classes, chlidClassName)
          },
          childProps
        )
      );
    });
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        ref,
        className: cn(
          "relative isolate flex w-full text-foreground-subtle",
          { "text-foreground-disabled": props.disabled },
          className
        ),
        ...props
      },
      clones
    );
  }
);

export {
  InputGroup
};
